import { Observable, Observer } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class DownloadPDFCommand<
  T extends object & { isDisabled?: boolean },
  S extends {
    downloadPdf: (el: T, args: unknown) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  label = "download Pdf";
  icon = "get_app";
  layout: "flat" | undefined;
  isLoading = false;
  private observer: Observer<unknown> = {
    next: (_) => (this.isLoading = false),
    error: (_) => (this.isLoading = false),
    complete: () => {},
  };
  constructor(public service: S) {}
  execute(el: T) {
    this.isLoading = true;
    this.service.downloadPdf(el, this.receiver?.extraFilterSbj.value).subscribe(this.observer);
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return this.receiver?.isLoading || this.isLoading || el?.isDisabled || false;
  }

  /*   get isLoading() {

    return this.service.excelIsLoading || false;
  } */
}
